<template>
  <auth-shell>
    <auth-card
      ref="card"
      title="Создание аккаунта"
      description="Создайте свой аккаунт, затем добавьте или выберите организацию."
      error-id="signup-server-error"
      :error-message="authError"
      :loading="submitting"
      :loading-message="currentRegistrationLoadingText"
    >
      <q-form class="auth-form" @submit.prevent="onSubmit">
        <q-input
          v-model="email"
          outlined
          label="Email"
          type="email"
          name="email"
          autocomplete="email"
          :disable="submitting"
          :aria-describedby="authError ? 'signup-server-error' : undefined"
          :rules="emailRules"
        >
          <template #prepend><q-icon name="email" aria-hidden="true" /></template>
        </q-input>

        <password-input
          v-model="password"
          autocomplete="new-password"
          :disable="submitting"
          :describedby="authError ? 'signup-server-error' : ''"
          :rules="passwordRules"
        />
        <password-input
          v-model="confirmPassword"
          label="Подтвердите пароль"
          name="password-confirmation"
          autocomplete="new-password"
          :disable="submitting"
          :rules="confirmRules"
        />

        <q-checkbox
          v-model="agreeTerms"
          :disable="submitting"
          label="Я принимаю пользовательское соглашение"
        />

        <q-btn
          unelevated
          no-caps
          color="primary"
          class="auth-submit"
          label="Создать аккаунт"
          type="submit"
          :loading="submitting"
          :disable="submitting || !agreeTerms"
        />
      </q-form>

      <template #footer>
        <p>Уже есть аккаунт? <router-link :to="{ name: 'signin' }">Войти</router-link></p>
      </template>
    </auth-card>
  </auth-shell>
</template>

<script>
import axios from 'axios'
import { AuthCard, AuthShell, PasswordInput } from '../../components/auth'
import { apiUrl } from '../../config'

const loadingTexts = [
  'Настраиваем окружение',
  'Договариваемся с налоговой',
  'Ищем нейробухгалтера',
  'Ловим связь с космической отчетностью'
]

export default {
  name: 'register',
  components: { AuthCard, AuthShell, PasswordInput },
  data() {
    return {
      email: '',
      password: '',
      confirmPassword: '',
      agreeTerms: false,
      submitting: false,
      authError: '',
      registrationLoadingIndex: 0,
      registrationLoadingTimer: null,
      emailRules: [
        (value) => Boolean(value) || 'Email обязателен',
        (value) => /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value) || 'Неверный формат email'
      ],
      passwordRules: [
        (value) => Boolean(value) || 'Введите пароль',
        (value) => value.length >= 8 || 'Пароль должен быть не короче 8 символов'
      ]
    }
  },
  computed: {
    currentRegistrationLoadingText() {
      return loadingTexts[this.registrationLoadingIndex] || loadingTexts[0]
    },
    confirmRules() {
      return [
        (value) => Boolean(value) || 'Подтвердите пароль',
        (value) => value === this.password || 'Пароли должны совпадать'
      ]
    }
  },
  beforeUnmount() {
    this.stopRegistrationLoading()
  },
  methods: {
    startRegistrationLoading() {
      this.registrationLoadingIndex = 0
      this.registrationLoadingTimer = window.setInterval(() => {
        this.registrationLoadingIndex = (this.registrationLoadingIndex + 1) % loadingTexts.length
      }, 2000)
    },
    stopRegistrationLoading() {
      if (this.registrationLoadingTimer !== null) window.clearInterval(this.registrationLoadingTimer)
      this.registrationLoadingTimer = null
    },
    showError(message) {
      this.authError = message
      this.$refs.card.focusError()
    },
    registerError(code) {
      if (code === 'user-exist') return 'Такой email уже используется'
      if (code === 'invalid-email') return 'Такой email не существует'
      if (code === 'weak-password') return 'Пароль должен быть не короче 8 символов'
      return 'Не удалось создать аккаунт'
    },
    async requestToken() {
      const response = await axios.post(`${apiUrl}/user/token/request/`, {}, {
        auth: { username: this.email, password: this.password }
      })
      if (response.data.token === undefined) throw new Error('missing-token')
      this.connection.updateCredentials(this.$q, response.data.token, response.data.token_uuid, true)
      this.connection.makeConnection(this.$q)
      this.$router.push({ name: 'profile' })
      if (response.data.user_info) this.emitter.emit('receiveUserInfo', response.data.user_info)
    },
    async onSubmit() {
      if (this.submitting || !this.agreeTerms) return
      this.submitting = true
      this.authError = ''
      this.startRegistrationLoading()
      try {
        const response = await axios.post(`${apiUrl}/register/`, { email: this.email, password: this.password })
        if (response.data.success !== 1) {
          this.password = ''
          this.confirmPassword = ''
          this.showError(this.registerError(response.data.error))
          return
        }
        await this.requestToken()
      } catch {
        this.showError('Сервер не отвечает, повторите попытку позже')
      } finally {
        this.stopRegistrationLoading()
        this.submitting = false
      }
    }
  }
}
</script>
